/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: ofin-webapp-contrib
 * Version: 7.1.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($) {
    'use strict';

    $.layoutManagerHandlers.registerCardHandler({
        'com.kosmos.offreformation.layout.card.bean.DescriptionCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.descriptionCard').addClass('actif_bloc').removeClass('inactif_bloc');

                } else {
                    $(view).find('.descriptionCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.ZoomAnneeCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.zoomanneeCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.zoomanneeCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.PublicsCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.publicsCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.publicsCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.RythmeCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.rythmeCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.rythmeCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.AdmissionCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.admissionCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.admissionCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.TemoignageCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.temoignageCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.temoignageCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.InternationalCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.internationalCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.internationalCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.InscriptionCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.inscriptionCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.inscriptionCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.DebouchesCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.debouchesCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.debouchesCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.VideoCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.videoCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.videoCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.SpecificitesCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.specificitesCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.specificitesCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.ProfessionnalisationCardBean': {
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.professionnalisationCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.professionnalisationCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        },
        'com.kosmos.offreformation.layout.card.bean.BlocLibreCardBean': {
            beforeEditOpen: function () {
                CKEDITOR_HELPER.beforeDomMove('contenubloclibre');
            },
            onEditActive: function () {
                CKEDITOR_HELPER.afterDomMove('contenubloclibre');
            },
            check: function (card) {
                if (card) {
                    if (card.model.affichebloc === true) {
                        return $.layoutManager.states.checked;
                    } else {
                        return $.layoutManager.states.incomplete;
                    }
                }
                return $.layoutManager.states.incomplete;
            },
            updateView: function(card, view) {
                if (card.model.affichebloc === true) {
                    $(view).find('.bloclibreCard').addClass('actif_bloc').removeClass('inactif_bloc');
                } else {
                    $(view).find('.bloclibreCard').addClass('inactif_bloc').removeClass('actif_bloc');
                }
                $.layoutManagerHandlers.cardDefaultUpdateView(card.model.titre, card.model.affichebloc, view);
            }
        }
    });
})(jQuery);
